module.exports = __webpack_public_path__ + "PTMETTAservice-5.3d05258a.png";